const en = require('./en');
const he = require('./he');
const { SUPPORTED_LANGUAGES } = require('../const');

module.exports = {
	[SUPPORTED_LANGUAGES.EN]: { ...en },
	[SUPPORTED_LANGUAGES.HE]: { ...he },
};
